import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';
import { Box, Typography } from '@mui/material';
const FaturacaoChart = ({ faturado, pendente, total }) => {
    const canvasRef = useRef(null);
    let chartInstance = null;
    useEffect(() => {
        const ctx = canvasRef.current.getContext('2d');
        if (chartInstance) {
            chartInstance.destroy();
        }
        chartInstance = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: ['Faturado', 'Pendente', 'Por faturar'],
                datasets: [
                    {
                        data: [faturado, pendente, total - faturado - pendente],
                        backgroundColor: ['#049a9b', '#ffb300', '#db4437']
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            }
        });
        // Cleanup on unmount
        return () => {
            chartInstance.destroy();
        };
    }, [faturado, pendente, total]);
    return (<Box sx={{
            p: 1,
            height: 200,
            width: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
      <canvas ref={canvasRef}></canvas>
      {total > 0 && (<Typography variant='button' sx={{ position: 'absolute', fontSize: '1.3rem' }}>
          {(faturado / total).toLocaleString('pt-PT', {
                style: 'percent',
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
            })}
        </Typography>)}
    </Box>);
};
export default FaturacaoChart;
